/**
 * æ¯å¦æ¯å¸å°ç±»å
 *
 * @param {Object} value æµè¯çå¼
 * @return {Boolean}
 */
import isType from './is-type';
var isBoolean = function (value) {
    return isType(value, 'Boolean');
};
export default isBoolean;
//# sourceMappingURL=is-boolean.js.map